import { gql } from '@apollo/client';
export const fetchRefundDetailQuery = gql`
  query fetchRefundDetailQuery($id: ID!) {
    refund(id: $id) {
      id
      arn
      creditNoteNumber
      transactionAccountId
      sourceSystem
      sourceSystemId
      memo
      reason
      reasonCode
      refundId
      chargeId
      rechargeInvoiceId
      status
      type
      createdDate
      refundedDate
      orderId
      creationNotes
      currency
      total
      totalExTax
      totalTax
      refundItems {
        id
        adjustments {
          amount
          reason
          type
        }
        invoiceLineItemId
        entitlementNumber
        entitlementId
        quantity
        description
        total
        totalExTax
        totalTax
        taxRate
        taxableAmount
        taxExemptAmount
        platform
        productId
        edition
      }
      billTo {
        fullName
        organization
        email
        address {
          address1
          address2
          city
          country
          phone
          postalCode
          state
        }
        taxId
      }
      shipTo {
        fullName
        organization
        email
        address {
          address1
          address2
          city
          country
          phone
          postalCode
          state
        }
        taxId
      }
      purchaseOrderNumber
      creditNoteId
    }
  }
`;
